










































import { Vue, Component } from "vue-property-decorator";
import api, { agentApi } from "@/getinfo-api";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import AgentInformation from "@/components/agent/AgentInformation.vue";
import { i18n } from "@/locales/settings";
import { LocalesFields } from "@/locales/translateInterface";
import { Agent as IAgent } from "@/api-v2/agent/models/agent";
import { User as IUser } from "@/api/models/user";

@Component({
  components: { AgentInformation, TextField, CBlock, CPage }
})
export default class AgentView extends Vue {
  agent?: IAgent;
  isLoading: boolean = false;
  user?: IUser;

  data() {
    return {
      agent: undefined,
      user: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "agents" },
        label: i18n.tc(LocalesFields.Agents)
      },
      {
        label: this.agent?.fullName
      }
    ];
  }

  get headerTitle() {
    return `${this.$tc(this.$translate.Agent)} ${
      this.agent ? this.agent?.fullName : ""
    }`;
  }

  async getUser(userId: string) {
    try {
      const { data } = await api.UsersApi.get(userId);
      this.user = data;
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    }
  }

  async getAgent() {
    try {
      this.isLoading = true;
      const { data } = await agentApi.Agent.getAgent(this.$route.params.id);
      this.agent = data;
      if (this.agent.userId) {
        await this.getUser(this.agent.userId);
      }
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  created() {
    this.getAgent();
  }
}
